"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("./asset-accessor");

var image_accessor_1 = require("./image-accessor");

var NullAccessor =
/** @class */
function () {
  function NullAccessor() {}

  NullAccessor.prototype.raw = function () {
    return undefined;
  };

  NullAccessor.prototype.field = function (fieldName) {
    return new NullAccessor();
  };

  NullAccessor.prototype.array = function (fieldName) {
    return [];
  };

  NullAccessor.prototype.object = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.text = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.longText = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.richText = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.slug = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.number = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype["boolean"] = function (fieldName, defaultValue) {
    return defaultValue;
  };

  NullAccessor.prototype.asset = function (fieldName) {
    return new asset_accessor_1.NullAssetAccessor();
  };

  NullAccessor.prototype.image = function (fieldName) {
    return new image_accessor_1.NullImageAccessor();
  };

  NullAccessor.prototype.type = function () {
    return asset_accessor_1.CommonAccessorType.UNDEFINED;
  };

  NullAccessor.prototype.file = function (fieldName) {
    return new asset_accessor_1.NullFileAccessor();
  };

  return NullAccessor;
}();

exports.NullAccessor = NullAccessor;

var ContentError =
/** @class */
function (_super) {
  __extends(ContentError, _super);

  function ContentError() {
    var params = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }

    var _this = _super.apply(this, __spread(params)) || this;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, ContentError);
    }

    _this.name = 'ContentError';
    _this.date = new Date();
    return _this;
  }

  return ContentError;
}(Error);

exports.ContentError = ContentError;